import _ from "lodash";
import { Suspense, useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import MainCard from "../../../Components/Cards/MainCard";
import { Input } from "../../../Components/CustomComponents";
import SelectFieldComponent from "../../../Components/CustomComponents/SelectFieldComponent";
import ToolTip from "../../../Components/CustomComponents/ToolTip";
import ChangePasswordModal from "../../../Components/Modals/ChangePasswordModal";
import DeleteModal from "../../../Components/Modals/DeleteModal";
import DetailUserModal from "../../../Components/Modals/DetailUserModal";
import Table from "../../../Components/Table/Table";
import {
  useBlockUserMutation,
  useUnBlockUserMutation,
} from "../../../Data/services/generalUserApi";
import Toast, { SuccessToast } from "../../../Hooks/useToast";
import styles from "../styles/user_management.module.scss";
import Header from "./Header";
import AgentApplicationSkeleton from "../../../Components/Skeleton/AgentApplicationSkeleton";

const AgentApplication = ({ data }) => {
  const { control, watch } = useForm({
    defaultValues: {
      status: "",
    },
  });
  const status = watch("status");
  // console.log(status);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo

  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [forView, setForView] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [dataFetched, setDataFetched] = useState(false);

  const filterData = [
    {
      value: "all",
      label: "All",
    },
    {
      value: 0,
      label: "Active",
    },
    {
      value: 1,
      label: "InActive",
    },
  ];

  const [dummyFetch, setDummyFetch] = useState({
    isLoading: true,
    isFetching: true,
  });

  useEffect(() => {
    setTimeout(() => {
      setDummyFetch((prev) => {
        return {
          ...prev,
          isLoading: false,
          isFetching: false,
        };
      });
    }, 2000);
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    setDataFetched(false);
  };

  const handleBlockModalOpen = () => {
    setViewModal(true);
  };

  const handleBlockModalClose = () => {
    setViewModal(false);
    setEditedData("");
  };

  const handlePasswordModalOpen = () => {
    setPasswordModal(true);
  };

  const handlePasswordModalClose = () => {
    setPasswordModal(false);
    setEditedData("");
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  // const [deleteUser, { isLoading: isDeleting }] = useDeleteUserMutation();

  const deleteData = async (slug) => {
    // try {
    //   // const { data } = await deleteUser(slug);
    //   // console.log(data);
    //   if (data.code === 200) {
    //     // await refetch();
    //     handleDeleteModalClose();
    //     SuccessToast(data.message);
    //   }
    // } catch (error) {
    //   // console.log(error);
    //   Toast(error.message, "error");
    // }
  };

  function indication() {
    return indicationMessage;
  }

  const [blockUser, { isLoading: isBlocking }] = useBlockUserMutation();
  const [unBlockUser, { isLoading: isUnBlocking }] = useUnBlockUserMutation();
  // const [userBlockOrUnBlock, { isLoading: isSwitching }] =
  //   useBlockUnblockUserMutation();

  const handleBlockOrUnblock = async (userSlug, isBlock) => {
    console.log(userSlug);
    console.log(isBlock);

    try {
      // const response = await userBlockOrUnBlock({ id: userSlug });
      // console.log(response);
      let response;
      if (isBlock) {
        response = await unBlockUser({ id: userSlug });
      } else {
        response = await blockUser({ id: userSlug });
      }
      console.log(response);

      if (response.data.code === 200) {
        // await refetch();
        setLoading(false);
        // handleBlockModalClose();
        SuccessToast(response.data?.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  const columns = [
    {
      dataField: "applicant",
      text: "Applicant",
      headerStyle: { width: "200px" },
      formatter: (cellContent, row) => (
        <div className="d-flex align-items-center gap-2">
          <div className="avatar bg-light rounded-circle p-2 fw-bold">
            {row.name
              .split(" ")
              .map((n) => n[0])
              .join("")}
          </div>
          <div>
            <div className="fw-bold">{row.name}</div>
            <div className="text-muted small">{row.email}</div>
          </div>
        </div>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "120px" },
      formatter: (cellContent) => (
        <span
          className={`badge rounded-pill ${
            cellContent === "Pending" ? "bg-warning text-dark" : "bg-success"
          }`}
        >
          {cellContent}
        </span>
      ),
    },
    {
      dataField: "experience",
      text: "Experience",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "120px" },
    },
    {
      dataField: "license",
      text: "License",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "150px" },
    },
    {
      dataField: "background",
      text: "Background Check",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "180px" },
      formatter: (cellContent) => (
        <span className="badge bg-success-subtle text-success fw-bold">
          {cellContent}
        </span>
      ),
    },
    {
      dataField: "submitDate",
      text: "Submit Date",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "120px" },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "200px" },
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex justify-content-center gap-2">
            <ToolTip placement={"top"} content={"View"}>
              <button
                className="btn btn-sm btn-light border rounded-circle"
                onClick={() => {
                  setForView(true);
                  setEditedData(row);
                  handleBlockModalOpen();
                }}
              >
                👁
              </button>
            </ToolTip>

            {/* <ToolTip placement={"top"} content={"Completed"}>
            <button className="btn btn-sm btn-success rounded-circle">✔</button>
          </ToolTip> */}
            <ToolTip placement={"top"} content={"Delete"}>
              <button
                className="btn btn-sm btn-danger rounded-circle"
                onClick={() => {
                  setForView(true);
                  setEditedData(row);
                  handleDeleteModalOpen();
                }}
              >
                ✖
              </button>
            </ToolTip>
          </div>
        );
      },
    },

    // {
    //   dataField: "is_blocked",
    //   text: "Status",
    //   // sort: true,
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "100px",
    //   },
    //   formatter: (cellContent, row) => {
    //     return (
    //       <SwitchWithLoader
    //         isChecked={!row.is_blocked}
    //         // isLoading={isBlocking || isUnBlocking}
    //         onChange={() => handleBlockOrUnblock(row.id, row.is_blocked)}
    //       />
    //     );
    //   },
    // },
    // {
    //   dataField: "actions",
    //   text: "Actions",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "100px",
    //   },
    //   formatter: (cellContent, row) => {
    //     // console.log(row)
    //     if (row.id) {
    //       return (
    //         <div className="d-flex justify-content-center align-items-center ">
    //           <ToolTip placement={"top"} content={"View Details"}>
    //             <div
    //               className="d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 "
    //               role="button"
    //               onClick={() => {
    //                 setForView(true);
    //                 setEditedData(row);
    //                 handleBlockModalOpen();
    //               }}
    //             >
    //               <span className={`d-flex align-items-center pe-1`}>
    //                 <IoIosEye size={22} />
    //               </span>
    //               {/* <span className="d-none d-xl-block">View</span> */}
    //             </div>
    //           </ToolTip>

    //           <ToolTip placement={"top"} content={"Change Password"}>
    //             <div
    //               className="d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 "
    //               role="button"
    //               onClick={() => {
    //                 setForView(true);
    //                 setEditedData(row);
    //                 handlePasswordModalOpen();
    //               }}
    //             >
    //               <span className={`d-flex align-items-center pe-1`}>
    //                 <MdLockReset size={22} />
    //               </span>
    //               {/* <span className="d-none d-xl-block">Change Pass</span> */}
    //             </div>
    //           </ToolTip>
    //         </div>
    //       );
    //     }
    //   },
    // },
  ];

  return (
    <>
      {passwordModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <ChangePasswordModal
            forView={forView}
            handleBlockModalClose={handlePasswordModalClose}
            data={editedData}
            // onAction={handlePassword}
            loading={loading}
          />
        </Suspense>
      ) : (
        ""
      )}

      {viewModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DetailUserModal
            // forView={forView}
            handleEditModalClose={handleBlockModalClose}
            editData={editedData}
            // onAction={handleBlockOrUnblock}
            // loading={loading}
          />
        </Suspense>
      ) : (
        ""
      )}

      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            // isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}
      <Header
        title={"Agent Application"}
        subTitle={"Review and manage agent onboarding applications"}
      />
      <br />
      <MainCard>
        {dummyFetch.isLoading ? (
          // <div className="d-flex justify-content-center">
          //   <Spinner />
          // </div>
          <AgentApplicationSkeleton />
        ) : (
          <>
            <Row>
              <Col xs={12} md={9}>
                <Input
                  placeholder="Search by name"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </Col>
              <Col xs={12} md={3}>
                <Controller
                  control={control}
                  name="status"
                  render={({ field: { onChange, value } }) => (
                    <SelectFieldComponent
                      firstOption={_.isEmpty(value) ? "Select Status" : value}
                      optionsList={filterData}
                      onSelectChange={onChange}
                    />
                  )}
                />
              </Col>
            </Row>

            <div
              // className={`${styles.mainTable} ${dataFetched && isFetching ? "blur-table" : ""}`}
              className={styles.mainTable}
            >
              {/* {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : ( */}
              <Table
                // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={data || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                // refetch={refetch} // todo
                refetch={() => {}}
              />
              {/* )} */}
            </div>
          </>
        )}
      </MainCard>
    </>
  );
};

export default AgentApplication;
